export default __webpack_public_path__ + "static/media/document.86484ce1.svg";